// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"246652c9","205":"9909f4a9","443":"c4c66b0b","712":"b3c338b9","925":"1abaa1bc"}[chunkId] + ".css";
};